<template>
  <div>
    <!-- <top-Navbar></top-Navbar> -->
    <main-page></main-page>
    <hr />
    <see-whatsinside></see-whatsinside>
    <meet-censeanalytics></meet-censeanalytics>
    <!-- <trusted-by></trusted-by> -->
    <!-- <footer-component> </footer-component>
    <common-footer> </common-footer> -->
  </div>
</template>
<script>
/* eslint-disable vue/no-unused-components */
// import TopNavbar from '../components/TopNavbar.vue'
import MainPage from '../components/MainPage.vue'
import SeeWhatsInside from '../components/SeeWhatsInside.vue'
import MeetCenseAnalytics from '../components/MeetCenseAnalytics.vue'
// import TrustedBy from '../components/TrustedBy.vue'
// import footer from '../components/Footer.vue'
// import CommonFooter from '../components/CommonFooter.vue'
export default {
  name: "LandingPage",
  components: {
    // "footer-component": footer,
    // "common-footer": CommonFooter,
    // "top-Navbar": TopNavbar,
    "main-page": MainPage,
    "see-whatsinside": SeeWhatsInside,
    // "trusted-by": TrustedBy,
    "meet-censeanalytics": MeetCenseAnalytics,
  }
};
</script>
<style scoped>

</style>